/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Disabled_Websites_SubtitleInputs */

const en_common_disabled_websites_subtitle = /** @type {(inputs: Common_Disabled_Websites_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage disabled websites`)
};

const es_common_disabled_websites_subtitle = /** @type {(inputs: Common_Disabled_Websites_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administra sitios bloqueados`)
};

/**
* | output |
* | --- |
* | "Manage disabled websites" |
*
* @param {Common_Disabled_Websites_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_disabled_websites_subtitle = /** @type {((inputs?: Common_Disabled_Websites_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Disabled_Websites_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_disabled_websites_subtitle(inputs)
	return en_common_disabled_websites_subtitle(inputs)
});